function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m5.541 146.624-.87 3.249-3.181.067a12.522 12.522 0 0 1-.09-11.672l2.832.519L5.47 141.6a7.46 7.46 0 0 0 .07 5.023z",
    transform: "translate(0 -131.516)",
    style: {
      fill: "#fbbb00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.635 208.176a12.495 12.495 0 0 1-4.456 12.083l-3.567-.182-.5-3.151a7.45 7.45 0 0 0 3.205-3.8h-6.684v-4.945h12.007z",
    transform: "translate(-248.853 -198.012)",
    style: {
      fill: "#518ef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.344 316.548a12.5 12.5 0 0 1-18.836-3.824l4.051-3.316a7.434 7.434 0 0 0 10.713 3.806z",
    transform: "translate(-29.02 -294.301)",
    style: {
      fill: "#28b446"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.705 2.878-4.05 3.315A7.433 7.433 0 0 0 32.7 10.085l-4.075-3.334a12.5 12.5 0 0 1 19.08-3.873z",
    transform: "translate(-27.227)",
    style: {
      fill: "#f14336"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcn);
export default __webpack_public_path__ + "static/media/google-icn.7aface5a92bfac56cd70d9eb1bf4e491.svg";
export { ForwardRef as ReactComponent };